// Components & Molecules
import PageHero from "../PageHero";
import PageSection from "../PageSection";
import ResourceHow from "./ResourceHow";
import PageForm from "../PageForm";
import Button from "../../../components/Mobile/Button";

// Icons & Images
import hero_bka_a from "../../../assets/img/ResourceProviders/Mobile/hero_bkg_a.jpg";
import hero_bka_b from "../../../assets/img/ResourceProviders/Mobile/hero_bkg_b.jpg";
import sect1_img from "../../../assets/img/ResourceProviders/Mobile/sect1_img.jpg";
import sect2_img from "../../../assets/img/ResourceProviders/Mobile/sect2_img.jpg";
import sect3_img from "../../../assets/img/ResourceProviders/Mobile/sect3_img.jpg";

import { ReactComponent as TailedArrowRightIcon } from "../../../icons/TailedArrowRightIcon.svg";

import config from "../../../config";
const { partnerDashboardUrl } = config;

const ResourceSections = () => {
  const bookDemoUrl =
    "https://calendly.com/homecook/homecook-resource-provider-demo";

  return (
    <>
      {/* Hero Section */}
      <PageHero
        bkg_a={hero_bka_a}
        bkg_b={hero_bka_b}
        sub_head={"Resource Providers"}
        main_head={
          <>
            <span className="text-primaryDark-400"> Monetize Your </span> Space
            Today
          </>
        }
        description="Transform your excess capacity into earnings with HomeCook’s reliable platform that allows you to safely manage bookings, receive payments and connect with pre- vetted food entrepreneurs."
        children={
          <>
            <Button
              label={
                <>
                  Partner Dashboard{" "}
                  <TailedArrowRightIcon className="w-[20px] h-[20px]" />
                </>
              }
              variant="secondary"
              onClick={() => {
                window.open(partnerDashboardUrl, "_blank");
              }}
            />
          </>
        }
      />

      {/* Section One */}
      <PageSection
        imgSrc={sect1_img}
        greyBkg
        header={
          <>
            <span className="text-primaryDark-400"> Diversify Revenue </span>{" "}
            Streams Effortlessly
          </>
        }
        description="List your kitchen with HomeCook and effortlessly tap into various revenue streams. Let your kitchen work for you by booking it to pre-vetted food entrepreneurs."
        button={{
          label: "Book Demo",
          onClick: () => {
            window.open(bookDemoUrl, "_blank");
          },
        }}
      />

      {/* Section Two */}
      <PageSection
        imgSrc={sect2_img}
        header={
          <>
            <span className="text-primaryDark-400"> Seamlessly </span> Manage
            Bookings
          </>
        }
        description="Easily manage bookings with HomeCook, set your availability, and stay in charge of your kitchen’s calendar."
        button={{
          label: "Book Demo",
          onClick: () => {
            window.open(bookDemoUrl, "_blank");
          },
        }}
      />

      {/* Section Three */}
      <PageSection
        imgSrc={sect3_img}
        greyBkg
        header={
          <>
            <span className="text-primaryDark-400">Bring Your</span> Community
            To HomeCook
          </>
        }
        description="Create and manage your own community on the platform, share valuable resources, and support food entrepreneurs while expanding your reach and impact."
        button={{
          label: "Book Demo",
          onClick: () => {
            window.open(bookDemoUrl, "_blank");
          },
        }}
      />

      {/* How It Works Section */}
      <ResourceHow />

      {/* Homecook Form */}
      <PageForm buttonLabel="Book Demo" />
    </>
  );
};

export default ResourceSections;
